/* eslint-disable @typescript-eslint/no-explicit-any */
import {pdf} from '@react-pdf/renderer';
import React from 'react';
import {MonAttestation} from './MonAttesation';

const saveBlob = (blob: any, filename: string, isCreatedOk: () => void) => {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = filename;
  a.click();
  isCreatedOk();
  window.URL.revokeObjectURL(url);
};

export const savePdf = async (
  document: any,
  filename: string,
  isCreatedOk: () => void,
) => {
  saveBlob(await pdf(document).toBlob(), filename, isCreatedOk);
};

export const createPDF = async (
  detailContrat: any,
  isCreatedOk: () => void,
) => {
  await savePdf(
    <MonAttestation detailContrat={detailContrat} />,
    detailContrat.typeContrat +
      '-' +
      detailContrat.nomPrenomSouscripteur +
      '.pdf',
    isCreatedOk,
  );
};
